import { api } from "./api";

export const pulsesApi = {
  feed: async (mode) => (await api.get(`/pulses/feed?mode=${mode}`)).data,
  create: async (payload) => (await api.post("/pulses", payload)).data,
  vote: async (pulseId, optionId) =>
    (await api.post(`/pulses/${pulseId}/vote`, { option_id: optionId })).data,
  vibra: async (pulseId) => (await api.post(`/pulses/${pulseId}/vibra`)).data,
  word: async (pulseId, word) =>
    (await api.post(`/pulses/${pulseId}/word`, { word })).data,
  adWalker: async (payload) => (await api.post("/ad-walker", payload)).data,
};

export const MOOD_PRESETS = [
  "Concentración Total",
  "Modo Fiesta",
  "Relax",
  "Creando",
  "Café ON",
  "Bajón",
];
